import type { IMarketsData, MarketsSortType } from 'customTypes/exchange';

export const getExchangeMarketsData = async (
	id: string,
	page: number,
	perPage: number,
	filterCoinId: string,
	filterCoinSymbol: string,
	sortBy: MarketsSortType,
	direction: 'asc' | 'desc',
	type: 'spot' | 'derivative',
): Promise<IMarketsData> => {
	try {
		const res = await fetch(
			`/api/exchanges/exchange-markets?id=${id}&page=${page}&size=${perPage}&filter=${filterCoinId}&symbol=${filterCoinSymbol}&sort=${sortBy}&direction=${direction}&type=${type}`,
		);
		return await res.json();
	} catch (error) {
		console.error(error);
	}
};
